import { render, staticRenderFns } from "./simple-search.vue?vue&type=template&id=06fd4e80&"
import script from "./simple-search.vue?vue&type=script&lang=js&"
export * from "./simple-search.vue?vue&type=script&lang=js&"
import style0 from "./simple-search.vue?vue&type=style&index=0&id=06fd4e80&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports